import React, { useState } from 'react';
import CustomDrawer from '../../components/shared/Drawer';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import './collectiveAgreement.css';
import CollectiveAccordion from './collectiveAccordion';
import { Loading } from '../../components/shared';
import BtButton from '../bt-button/bt-button';
import TooltipContainer from '../../components/shared/TooltipContainer/TooltipContainer';
import { useTranslation } from 'react-i18next';

export default function CollectiveAgreement({ agreementData, loading, error }) {
  const [t] = useTranslation('supplierDatabase', { keyPrefix: 'supplierControls' });
  const [drawerState, toggleDrawerState] = useState(false);
  let totalCount = 0;
  if (agreementData) {
    let { kollektivavtalskollen, byggInstSektorn } = agreementData;
    totalCount = kollektivavtalskollen.source_data.length +
      byggInstSektorn.collectiveAgreements.length +
      byggInstSektorn.substituteAgreements.length;
  }

  const agreementTeller = () => {
    if (error) {
      return error;
    }

    const noAgreement = !agreementData || totalCount == 0;

    let title = ``;
    if (!noAgreement) {
      if (agreementData.kollektivavtalskollen?.source_data?.length) {
        const agreements = (agreementData.kollektivavtalskollen.source_data).reduce((total, source) => {
          total = [...total, ...(source?.agreements ?? []).map(agreement => agreement.agreement)];
          return total;
        }, []);
        title = t('collectiveAgreement.summary.kollektivavtalskollen', 'Kollektivavtalskollen: Har {{agreements_list}}.\n', { agreements });
      }
      if (agreementData.byggInstSektorn) {
        title += t('collectiveAgreement.summary.byggInstSektorn.prefix', 'Bygg- och installationssektorn: ');
        if (agreementData.byggInstSektorn.memberships?.length) {
          title += t('collectiveAgreement.summary.byggInstSektorn.memberships', 'Medlem i {{memberships_list}}. ', { memberships: agreementData.byggInstSektorn.memberships.map(m => m.name) });
        }
        let totalAgreements = [];
        if (agreementData.byggInstSektorn.collectiveAgreements?.length) {
          totalAgreements = totalAgreements.concat(agreementData.byggInstSektorn.collectiveAgreements.map(agreement => agreement.Avtal));
        }
        if (agreementData.byggInstSektorn.substituteAgreements?.length) {
          totalAgreements = totalAgreements.concat(agreementData.byggInstSektorn.substituteAgreements.map(agreement => agreement.Avtal));
        }
        if (totalAgreements.length) {
          title += t('collectiveAgreement.summary.byggInstSektorn.agreements', 'Har {{agreements_list}}.', { agreements: totalAgreements });
        }
      }
    }

    return loading ? (
      [<div key="loader"><Loading loadingStyle="bubbles" type='inline' color="#ff5e15" size='30px' /></div>, <div key="empty"></div>]
    ) : (<>
      <div key="indicator">
        {totalCount > 0 ? (
          <div className="collective-agreementFlag true" title={title}>
            <CheckIcon /> {t('label.yes', 'Ja')}
          </div>
        ) : (
          <TooltipContainer renderReferenceComponent={(className, ref) =>
            <div ref={ref} className={`collective-agreementFlag false ${className}`}>
              <CloseIcon /> {t('label.no', 'Nej')}
            </div>
          }>
            <p style={{width: "25em", textAlign: "left"}}>
              {t(
                'collectiveAgreement.info.kollektivavtalskollen',
                'Vi visar data från tjänsten Kollektivavtalskollen som inkluderar avtal med Byggnads, Kommunal, Fastighet, Elektrikerna, Handels, Målarna, Akavia, Forena och Finansförbundet (fler förbund/avtal kommer, denna lista är senast uppdaterad 2024-08-21).'
              )}
            </p>
            <p style={{width: "25em", textAlign: "left"}}>
              {t(
                'collectiveAgreement.info.byggInstSektorn',
                'Vi hämtar också data från Bygg- och installationssektorn som innehåller information från arbetsgivarorganisationer och inkluderar medlemskap, kollektivavtal och hängavtal från Byggföretagen, Installatörsföretagen, Maskinentreprenörerna, Plåt & Ventföretagen, Måleriföretagen och Glasbranschföreningen.'
              )}
            </p>
          </TooltipContainer>
        )}
      </div>
      <div key="button">
        <BtButton
          color="white"
          size="xxs"
          disabled={noAgreement}
          class='supplierControlsElementToHide'
          onClick={() => {
            if (noAgreement) return;
            toggleDrawerState(!drawerState);
          }}
          key="button"
        >{t('collectiveAgreement.button.show', 'Visa avtal')}</BtButton>
      </div>
    </>);
  };

  return (
    <React.Fragment>
      {agreementTeller()}
      <CustomDrawer position="right" isOpen={drawerState} toggleDrawer={toggleDrawerState}>
        <div className="custom-drawer-body">
          <CollectiveAccordion data={agreementData} />
        </div>
      </CustomDrawer>
    </React.Fragment>
  );
}
